import React , {Component} from 'react'
import '../assets/css/style.css'
export default  class En extends Component{
  render(){
    return(

       <div>
  <title>GAMEX THE ACCIDENT RECOVERY EXPERT OF ROAD TRANSPORTATION</title>
        <div className="top_nav">
          <div className="container">
            {/*<span className="btn btn-primary btn-sm pull-right" data-toggle="modal" data-target=".login_modal">Connect</span>*/}
            <a href="/expert-en-sinistre" className="btn btn-primary btn-sm  pull-right">FR</a>  
          </div></div>  
        <header id="header">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-8 col-sm-8 ">
                <h1 className="en">
                  <span>EVERYTHING IS</span><span>EASIER WHEN WE</span><span>WORK TOGETHER</span>
                </h1>
                {/*<a href="#pourquoi_gamex" class="btn btn-primary">Discover Gamex</a>*/}
                <a href="/accident-recovery-expert/contact" className="btn btn-primary btn-lg hidden-xs">Contact Us</a>
                <a href="tel:18666354402" className="btn btn-primary btn-lg visible-xs">Contact Us</a>
              </div>
              <div className="col-lg-6 col-md-4 col-sm-4 ">
                <img className="img-responsive logo" src="img/gamex_sinistre_en.png" alt="GAMEX THE ACCIDENT RECOVERY EXPERT OF ROAD TRANSPORTATION" />
              </div>
            </div>
          </div>
        </header>
        <div className="scroller_anchor" />
        <nav id="navigation" className="scroller" >
          <ul className="nav">
            <li id="accueil" className="col-md-2 col-sm-3 col-xs-3"><a href="#header">Home</a></li>
            <li className="col-md-2 col-sm-3 col-xs-3 "><a href="#gamex_plus">About</a></li>
            <li className="col-md-2 col-sm-3 col-xs-3"><a href="#pourquoi_gamex">Expertise</a></li>
            <li className="col-md-2 col-sm-3 col-xs-3"><a href="/accident-recovery-expert/contact">Contact Us</a></li>
          </ul>
          <div className="col-md-2 hidden-sm hidden-xs" />
          <div className="col-md-2 hidden-sm hidden-xs" />
        </nav>    
        <section id="services">
          <div className="container">
            <div className="row">
              <div className="col-xs-12">
                <p className="lead">
                  GAMEX—the road transport accident recovery expert—is the best asset an insurance company and its clients can have. If you are in insurance and want to free yourself from the time-consuming tasks involved, contact us and see how much time and money we can save you.        </p>
                <button className="btn btn-primary" data-toggle="modal">Get personalized presentation</button>
                <a className="btn btn-primary " href="/accident-recovery-expert/contact">Can’t connect?</a>
              </div>
            </div>
            {/*
    <hr />
    <div class="row">

      <div class="col-md-4">
        <a class="btn btn-primary" href="#pourquoi_gamex">Logistics</a>
        
      </div>
      <div class="col-md-4">
        
        <a class="btn btn-primary" href="#pourquoi_gamex">Management</a>
        
      </div>
      <div class="col-md-4">
        <a class="btn btn-primary" href="#pourquoi_gamex">Storage</a>
        
      </div>
    </div>
    */}
          </div>
        </section>
        <section id="gamex_plus">
          <div className="container marker_container">
            <div className="marker_holder">
              <div className="section_marker">About</div>
              <div className="pointer_left" />
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-sm-4">
              </div>
              <div className="col-sm-4">
                <img className="img-responsive" src={require('../assets/img/logo_groupe_gamache_en.png')} alt="Gamache groupe" />
              </div>
              <div className="col-sm-4">
              </div>
              <div className="col-xs-12">
                <p className="lead">The Gamache Group has been a leader in the North American used heavy vehicle industry for over 45 years. It occupies a prominent place in Canada and the northeastern United States, offering comprehensive services to the industry. </p>
                <p className="lead">The Gamache Group:</p>
                <p>
                </p><ul>
                  <li>Gamache Montreal and Gamache Truck Center (purchase/sale of heavy trucks and related service points in Toronto, ON and Champlain, NY)
                    <ul>
                      <li>G-Financing (Financing, refinancing and extended warranties)</li>
                      <li>Gamache Tires (Sale of new and used tires and rims)</li>
                      <li>Repossession service for institutions specializing in financing heavy vehicles and equipment </li>
                    </ul>
                  </li>
                  <li>GAMEX (Export and sale of heavy-truck parts and leading Canadian expert in transport accident recovery)</li>
                </ul><p />
                <p>We are the heavyweight experts!</p>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-4">
                <img className="img-responsive" src="img/gamex_esportation_en.png" alt="GAMEX export" />
                {/*<h4>GAMEX export</h4>*/}
                <p>GAMEX exports a vast array of parts and used heavy trucks and trailers to over 35 countries worldwide.</p>
              </div>
              <div className="col-sm-4">
                <img className="img-responsive" src="img/gamex_sinistre_en.png" alt="GAMEX the accident recovery expert" />
                {/*<h4>GAMEX the accident recovery expert</h4>    */}
                <p>GAMEX, road accident transportation recovery experts, is the ally of choice for insurance companies and their clients.</p>
              </div>
              <div className="col-sm-4">
                <img className="img-responsive" src="img/gamex_pieces_en.png" alt="GAMEX parts" />
                {/*<h4>GAMEX parts</h4>     */}
                <p>GAMEX is the largest supplier of used heavy vehicle parts to dealers, repair shops and businesses in Quebec, Ontario and the Northeastern United States.</p>
              </div>
            </div>
            <hr />
          </div>
          {/*
  <div class="container">

      <div class="col-md-12">
        <h2>Trust the Group</h2>
        <p class="lead">
          GAMEX, a subsidiary of GAMACHE GROUP, exports a wide variety of parts, used heavy trucks and trailers to nearly 35 countries around the world.

        </p>
        
        <p>
          GAMEX is the biggest supplier of used parts for heavy vehicles to dealers, repair shops and businesses in Quebec, Ontario and the northeastern United States.
        </p>
        <p>
          High-quality Used Truck Parts for All Needs
Whether you're looking for engines, transmissions, differentials, suspensions, cabs or any other truck parts, or for damaged trucks, whole or in parts, you'll find exactly what you need at GAMEX.
        </p>        
        
        
          <p>
            GAMEX is a member of the Gamache Group, a leader in used heavy vehicle rentals. A well-established company, an unbeatable service, a solid structure, with a qualified and dedicated team. Gamex markets in almost 35 countries and a prime selection of trucks and parts. Gamex and the Gamache Group offer only the best to their clients.
          </p>
          <p>
            We offer turnkey services to insurance companies. When the insured makes a claim with their insurance company, their insurance company can contact Gamex, who will then take care of the equipment affected by the disaster quickly and efficiently. From towing the damaged equipment until it’s restored to good working order, including cargo management, Gamex executes every stage with professionalism, efficiency and speed.
          </p>
      
            </div>
  </div>
  */}
        </section>
        <section className="gamex_plus">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2>UNBEATABLE SERVICE</h2>
                <p>
                  Experienced mechanics and technicians carefully prepare the heavy truck parts and equipment specified by the client. GAMEX takes charge of all the logistical aspects of transporting parts and vehicles, minimizing costs.
                </p>      </div>
            </div>
          </div>
        </section>
        <section id="demo_video">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h1>Gamex, around the world <span className="text-muted">for you</span></h1>
                <video id="gamex_sat" poster={require("../assets/media/gamex_sat_poster.jpg")} >
                  <source src={require('../assets/media/gamex_sat_en.mp4')} type="video/mp4" />
                  <source src={require("../assets/media/gamex_sat_en.webm")} type="video/webm" />
                  <source src={require("../assets/media/gamex_sat_en.ogv")} type="video/ogg" />
                </video>
                <p className="lead">
                  Whether a transportation incident or exporting parts, you can be sure that <strong>Gamex</strong>, with its solid know-how gained through years of experience, will deliver a successful project, giving you peace of mind.        </p>
              </div>
            </div>
          </div>
        </section>
        <section id="reussite" className="hidden-xs">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-8 col-sm-9 col-xs-10">
                <h1 className="en">
                  <span>FOR 100%</span>
                  <span>SUCCESS,</span>
                  <span>ONE NAME STANDS OUT:</span>
                  <span className="logotype">Gamex</span>
                  <span>THE ROAD</span>
                  <span>TRANSPORT</span>
                  <span>ACCIDENT RECOVERY EXPERT</span>
                </h1>
                <a href="/accident-recovery-expert/contact" className="btn btn-primary btn-lg hidden-xs">Contact Us</a>
                <a href="tel:18666354402" className="btn btn-primary btn-lg visible-xs">Contact Us</a>
              </div>
            </div>
          </div>
        </section>
        <section id="pourquoi_gamex">
          <div className="container marker_container">
            <div className="flags" />
            <div className="marker_holder">
              <div className="section_marker">Expertise</div>
              <div className="pointer_left" />
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2>WHY CHOOSE <span className="logotype">GAMEX</span>, accident recovery expert?</h2>
                <p className="lead">
                  GAMEX has been offering outstanding post-accident logistical services for mishaps involving heavy vehicles, boats, trailers, etc., for many years now. We are available around the clock, 24/7.     </p>
                <hr />
                <button id="mobileDesc_btn" className="btn btn-primary visible-xs" type="button" data-toggle="collapse" data-target="#mobileDesc" aria-expanded="false" aria-controls="mobileDesc">
                  Learn more      </button>
                <div className="collapse" id="mobileDesc">
                  <div className="row visible-xs">
                    <div className="col-md-12">
                      <p>
                        Whether there's been an accident, fire, flood or other disaster, GAMEX will take charge of your equipment and handle everything from start to finish.
                      </p>
                      <blockquote>
                        The importance of a rapid and well-prepared response can often make a difference and reduce your loss.
                      </blockquote>
                      <p>
                        We provide our services throughout Canada and the US, in French, English and Spanish. No matter the extent of damage to your equipment, we are there to help. 
                      </p>
                      <p>
                        GAMEX is there for you, 24/7.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row hidden-xs">
                  <div className="col-md-12">
                    <p>
                      Whether there's been an accident, fire, flood or other disaster, GAMEX will take charge of your equipment and handle everything from start to finish.
                    </p>
                    <blockquote>
                      The importance of a rapid and well-prepared response can often make a difference and reduce your loss.
                    </blockquote>
                    <p>
                      We provide our services throughout Canada and the US, in French, English and Spanish. No matter the extent of damage to your equipment, we are there to help. 
                    </p>
                    <p>
                      GAMEX is there for you, 24/7.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/*
    <div class="row">
      <div class="col-md-12">
        <a href="#contact" onclick="lift_contact();" class="btn btn-primary">Contact Us</a>
      </div>
    </div>
    
    */}
          </div>
        </section>
        <section>
          <div className="container">
            <div className="row">
              <div className="col-md-4">
                <h3>Logistics</h3>
                <p>
                  GAMEX looks after your interests! We take charge of your file and manage logistics as soon as you contact us. We handle your case until the final settling up.    
                </p>
              </div>
              <div className="col-md-4">
                <h3>Management</h3>
                <p>
                  Once your case is in our capable hands, you will enjoy peace of mind for your equipment, documents and the rest! Whatever happens, we will take care of it.   
                </p>
              </div>
              <div className="col-md-4">
                <h3>Storage</h3>
                <p>
                  Vehicles and cargo stay safely in our facility. We have the space you need for the time you need, at no additional cost.    
                </p>
              </div>
            </div>
          </div>
        </section>
        <section id="ramassage_cargaison">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <h3>Cargo Pickup</h3>
                <p>We manage and warehouse your cargo following an accident. We handle the logistics of your case and take care of all documentation.</p>
              </div>
              <div className="col-md-6">
                <h3>Heavy Vehicle Recovery</h3>
                <p>We will store your vehicle or damaged rolling stock until your file is finalized. We make logistics and everything else easy.</p>
              </div>
            </div>
          </div>
        </section>
        <section id="faq">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h1>FAQ</h1>
              </div>
            </div>
            <div className="row">
              <div className="col-md-5">
                <div className="bulle">
                  <h2>Can you handle refrigerated cargo?</h2>
                </div>
              </div>
              <div className="col-md-6">
                <div className="reponse">
                  Of course! We cannot only recover refrigerated and frozen cargo, we can store your contents until the end of the process or even deliver them to the recipient as though nothing had happened.        </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-5">
                <div className="bulle">
                  <h2>What happens if the accident is in the United States?</h2>
                </div>
              </div>
              <div className="col-md-6">
                <div className="reponse">
                  We travel right to the scene of the accident and recover the damaged vehicle and its cargo. Once back at our facilities, we will proceed with the next steps.       </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-5">
                <div className="bulle">
                  <h2>What will happen once the cargo is recovered?</h2>
                </div>
              </div>
              <div className="col-md-6">
                <div className="reponse">
                  It all depends on what you need. If your circumstances require delivery to the consignee, we’ll deliver. If you must dispose of the goods, we’ll contact the vendor for a destruction notice. We can also store the goods in our warehouses until further notice.       </div>
              </div>
            </div>
          </div>
        </section>
        {/*
<section>
  
  <div class="container">
    
    <div class="row">
      
      <div class="col-md-12">
        <h3>Contact us for more information on our services and rates. <a href='https://expertensinistre.groupegamache.com/gamex.php?lang=en#faq'>Our FAQ</a>: will answer most of your questions.</h3>
        <a href="#contact" onclick="lift_contact();" class="btn btn-primary hidden-xs">Contact Us</a>
        <a href="tel:18666354402" class="btn btn-primary btn-lg visible-xs">Contact Us</a>

      </div>
    </div>
  </div>
</section>
*/}
        <div className="container">
          <div className="row">
            <hr />
            <div className="row last_row">
              <div className="col-md-12">
                <h3>Contact us for more information on our services and rates. Our FAQ: will answer most of your questions.</h3>
                <a href="/accident-recovery-expert/contact" className="btn btn-primary hidden-xs">Contact Us</a>
                <a href="tel:18666354402" className="btn btn-primary btn-lg visible-xs">Contact Us</a>
              </div>
            </div>
          </div>
        </div>
        <footer className>
          <div className="container">
            <div className="col-md-12">
              <h1>GAMEX the accident recovery expert</h1>
            </div>
          </div>
        </footer>
        <div className="modal fade login_modal" tabIndex={-1} role="dialog" aria-labelledby="login_modal">
          <div className="modal-dialog modal-sm">
            <form action="modal_login.php" method="post">
              <div className="modal-content">
                <h1>
                  PLEASE LOG IN   </h1>
                <p className="lead">
                  You need to be logged in to access this section.    </p>
                <div className="form-group">
                  <input className="form-control" type="text" name="email" placeholder="Email" required />
                </div>
                <div className="form-group">
                  <input className="form-control" type="password" name="pass" placeholder="Password" required />
                </div>
                <div className="form-group">
                  <button type="submit" name="btn-login" className="btn btn-primary">Connect</button>
                  <hr />
                  <a className href="/accident-recovery-expert/contact">Can’t connect?</a>
                </div>
              </div>
            </form>
          </div>
        </div>
       
      </div>












      )
  }
}


// WEBPACK FOOTER //
// ./src/components/En.js